'use client';

import { NewsContent, NewsForm, NewsList } from '@/components/global';
import { PageProps } from '@/lib/types';
import { Breadcrumb, Section } from '@/ui';
import { Content, NewsCard } from '@/widgets';
import { ComboboxItem, Container } from '@mantine/core';
import { useSearchParams } from 'next/navigation';
import { Suspense, useState } from 'react';

type Props = {
  data: PageProps;
  options: ComboboxItem[];
};

export default function News({ data, options }: Props) {
  const searchParams = useSearchParams();
  const [params, setParams] = useState({
    text: searchParams.get('text') || '',
    start_date: searchParams.get('start_date') || null,
    end_date: searchParams.get('end_date') || null,
    activity_id: searchParams.get('activity_id') || null,
  });

  const breadcrumbItems = [
    { title: data?.breadcrumb, href: `/general-menu/${data?.menu_id}` },
    { title: data?.menu_item_title, isCurrent: true },
  ];

  return (
    <Container>
      <Section rightMenu={{ isActive: true, id: data?.menu_id, activeItem: { id: data?.menu_item_id } }}>
        <Content>
          <Content.Header>
            <Breadcrumb items={breadcrumbItems} />
          </Content.Header>
          <Content.Title>{data?.menu_item_title}</Content.Title>
          <Content.Body className="flex flex-col gap-8">
            <Suspense>
              <NewsForm options={options} params={params} setParams={setParams} />
            </Suspense>
            <Suspense
              fallback={
                <NewsList>
                  <NewsCard.Loading count={6} />
                </NewsList>
              }
            >
              <NewsContent queryParams={params} />
            </Suspense>
          </Content.Body>
        </Content>
      </Section>
    </Container>
  );
}
